import React from 'react';
import { Stack, Shimmer, ShimmerElementType } from '@fluentui/react';

interface ShimmerListProps {
  rows?: number;
}

const shimmerRow = [
  { type: ShimmerElementType.gap, width: 20 },
  { type: ShimmerElementType.circle, width: '5%', height: 8 },
  { type: ShimmerElementType.gap, width: 20 },
  { type: ShimmerElementType.line, width: '40%', height: 36 },
  { type: ShimmerElementType.gap, width: 40 },
  { type: ShimmerElementType.line, width: '40%', height: 36 },
  { type: ShimmerElementType.gap, width: 40 },
  { type: ShimmerElementType.line, width: '15%', height: 36 },
  { type: ShimmerElementType.gap, width: 40 },
  { type: ShimmerElementType.line, width: '5%', height: 36 },
];

export const PriorityListShimmer: React.FC<ShimmerListProps> = ({
  rows = 6,
}) => {
  return (
    <Stack tokens={{ padding: '20px 0px', childrenGap: 12 }}>
      {Array.from({ length: rows }).map((_, index) => (
        <Shimmer key={index} shimmerElements={shimmerRow} />
      ))}
    </Stack>
  );
};